var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87463 8.73095C9.08357 8.73095 10.8743 6.94026 10.8743 4.73132C10.8743 2.52239 9.08357 0.731689 6.87463 0.731689C4.6657 0.731689 2.875 2.52239 2.875 4.73132C2.875 6.94026 4.6657 8.73095 6.87463 8.73095Z",
    fill: "#00504E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87445 10.0637C3.56272 10.0678 0.879031 12.7514 0.875 16.0632C0.875 16.4313 1.17344 16.7298 1.5416 16.7298H12.2073C12.5754 16.7298 12.8739 16.4313 12.8739 16.0632C12.8699 12.7514 10.1862 10.0678 6.87445 10.0637Z",
    fill: "#00504E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5402 5.98169C14.7679 6.02015 14.1719 6.67572 14.207 7.44821C14.2421 6.67572 13.6461 6.02015 12.8738 5.98169C12.1014 6.02015 11.5054 6.67572 11.5405 7.44821C11.5405 8.60145 13.0444 9.95264 13.7937 10.5539C14.0352 10.7473 14.3787 10.7473 14.6203 10.5539C15.3695 9.95398 16.8734 8.60145 16.8734 7.44821C16.9085 6.67569 16.3126 6.02015 15.5402 5.98169Z",
    fill: "#00504E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowing);
export default __webpack_public_path__ + "static/media/following.441dadfc5580d0f28c872c3c1adc2baf.svg";
export { ForwardRef as ReactComponent };